




import { Component, Prop } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import HavingWebRTCMediaMixin from '@/mixins/webrtc/havingWebRTCMediaMixin'
import { MediaComponentProps } from '@/components/common/videoCallRoom/VideoCallRoomContainer.vue'

@Component
export default class VideoCallAudio extends mixins(HavingWebRTCMediaMixin) {
  @Prop(Object) participant!: MediaComponentProps

  mounted() {
    const { stream, muted } = this.participant
    this.initialize(stream, muted)
  }
}
